import React, { useEffect, useState } from 'react';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Card, CardBody, CardHeader, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane, Table } from 'reactstrap';
import classnames from "classnames";




const breadcrumbLinks = [
    { to: '#', label: 'Inicio' },
    { to: '#', label: 'Empresa' },
    { to: '#', label: 'Configuración' }
];


const DashboardWarehouse = () => {

    const [activeTab, setactiveTab] = useState("1");
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* <BreadCrumb title="Dashboard Establecimiento" links={breadcrumbLinks} /> */}

                    <Row className='layout-dashboard'>
                        <Col md={2}>
                        
                        </Col>

                        <Col md={10}>

                        </Col>
                    </Row>
                </Container>

            </div>
        </React.Fragment>
    );
};

export default DashboardWarehouse;